import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { catchError, finalize, map } from "rxjs/operators";
import { environment } from "src/environments/environment";
import { User } from "../domain/user";
import { Permissions } from "../domain/user-profile/permissions";
import { CoreData } from "../tools/core-data/core-data";
import { LoadingTask } from "../tools/ui/loading-task";
import { BaseService } from "./base-service";
import { MatSnackBar } from "@angular/material/snack-bar";

@Injectable({
    providedIn: 'root',
})
export class UserService extends BaseService {

    private serviceUrl = `${environment.serviceBaseUrl}api/user`;

    constructor(public http: HttpClient,
        protected override coreData: CoreData,
        protected snackBare: MatSnackBar,
        private loadingTask: LoadingTask,
        protected override router: Router) {

        super(router, coreData, snackBare);
    }

    getRolePermissions() {
        this.loadingTask.activateLoading();
        return this.http.get(`${this.serviceUrl}/Role`, this.generateHeader()).pipe(
            catchError(this.handleError<any>('getRoles')),
            finalize(() => this.loadingTask.deactivateLoading()),
            map((response: Permissions[]) => {
                return response.map((item: Permissions) => {
                    return Permissions.mapFromJSON(item);
                });
            }));
    }    
}